import TagManager from 'react-gtm-module';
import config from '../src/client/config';

const { gtmId } = config;

try {
  const tagManagerArgs = {
    gtmId,
    dataLayerName: 'PageDataLayer',
  };

  TagManager.initialize(tagManagerArgs);
} catch (e) {
  /* eslint no-empty:0 */
}
